import {style} from '../style';

type Props = {
  name: string;
  children: React.ReactNode;
};
export function StackedCheckboxGroup(props: Props): React.JSX.Element {
  return (
    <fieldset aria-label={props.name} className={style.root}>
      {props.children}
    </fieldset>
  );
}

StackedCheckboxGroup.displayName = 'StackedCheckboxGroup';
